import VersionManagerCore from './versionManager.js';
import {utils} from '../utils'

var minDate = -8640000000000000;
const featuresList = {
      "fullscreen" : [{
        version: VersionManagerCore.Versions.min,
        dateFrom: minDate,
      }, {
        version: "V2",
        dateFrom: new Date(2018, 1, 1).getTime(),
      }]
};

class ProGalleryVersionManager {
  constructor(dateCreated, options) {
    const features = (options && options.features) ? options.features : featuresList;
    this.versionManager = new VersionManagerCore(features, dateCreated);
  }

  getVersionFullscreenVersion() {
    const version = this.versionManager.getVersion('fullscreen');
    if (version == VersionManagerCore.Versions.min) {
      return utils.isStoreGallery() ? "V2" : version;
    }
    return version;
  }

  useFullScreenWideSidebar() {
    return this.getVersionFullscreenVersion() != VersionManagerCore.Versions.min;
  }

  useFullScreenMobilePadding() {
    return this.getVersionFullscreenVersion() != VersionManagerCore.Versions.min;
  }

  useFullScreenMoreinfoButtonAlways() {
    return this.getVersionFullscreenVersion() == VersionManagerCore.Versions.min;
  }

  useFullscreenNewDesktopNavbar() {
    return this.getVersionFullscreenVersion() != VersionManagerCore.Versions.min;
  }

  useFullscreenNewSidebar() {
    return this.getVersionFullscreenVersion() != VersionManagerCore.Versions.min;
  }

  useFullscreenNewSlider() {
    return this.getVersionFullscreenVersion() != VersionManagerCore.Versions.min;
  }

  useFullscreenNewMobileLayout() {
    return this.getVersionFullscreenVersion() != VersionManagerCore.Versions.min;
  }
}

let dateCreatedTicks = null;
const isDateCreatedValid = isNaN(Date.parse(window.dateCreated)) === false;
if (window && window.petri && window.petri["specs.pro-gallery.StoreExpandMode"] === "true") {
  dateCreatedTicks = new Date(2018, 1, 2).getTime();
} else if (isDateCreatedValid) {
  dateCreatedTicks = Date.parse(window.dateCreated);
}

const versionManager = new ProGalleryVersionManager(dateCreatedTicks, featuresList);

module.exports = {ProGalleryVersionManager, versionManager, VersionManagerCore};



// WEBPACK FOOTER //
// ./versioning/proGalleryVersionManager.js